import { csProcessIdRegex } from './regularExpressions';

export function searchTextMatchesProcessId(trimmedSearchText: string) {
    return trimmedSearchText.match(csProcessIdRegex);
}
